import HyperDiv from 'components/ProjectNonSpecificComponents/Elements/HyperDiv/HyperDiv'
import React from 'react'

interface Props {
  children?: React.ReactNode
}

const CenteredContentTemplate = ({
  children,
}: Props) => {
  return (
    <HyperDiv
      className='fill-cter'
      style={{ minHeight: '80vh', paddingBottom: '3.5rem' }}
      centered
    >
      {children}
    </HyperDiv>
  )
}

export default CenteredContentTemplate
